// removed by extract-text-webpack-plugin
module.exports = {"container":"container__2N0ju","textContainer":"textContainer__1QbtX","contactFormContainer":"contactFormContainer__3C9lN","helloText":"helloText__2matt","callUsText":"callUsText__3hL6p","content":"content__vKtgG"};


//////////////////
// WEBPACK FOOTER
// ./components/contact/contact.css
// module id = HZyB
// module chunks = 0